import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, first, tap } from 'rxjs/operators';

import { ComponentAbstract } from '@app/components/abstract/component.abstract';
import { AppVersionService } from '@app/services/app-version.service';
import { AppRoutes } from '@shared/constants/app-routes.const';
import { MainPageActions } from '@shared/enums/main-page-actions';
import { selectDashboardViewType, selectLoadEnumerationsLoading } from '@shared/selectors/enumeration.selectors';
import { SnackbarService } from '@ui-components/components/customized-snackbar/snackbar.service';
import { environment } from 'src/environments/environment';

import { ScreenWiperService } from '../../../services/screen-wiper.service';
import { SidePanelService } from '../../../services/side-panel.service';

@UntilDestroy()
@Component({
  selector: 'app-application-menu',
  templateUrl: './application-menu.component.html',
  styleUrls: ['./application-menu.component.scss'],
  providers: [SidePanelService],
})
export class ApplicationMenuComponent extends ComponentAbstract implements OnInit {
  screenWipeStatus$ = this.screenWiperService.screenClasses$;
  wipeDuration = this.screenWiperService.wipeDuration;
  wiperVisible$ = this.screenWiperService.globalWiperVisible$;
  environment = environment;
  isAuthenticated = false;
  currentVersion = '';
  currentVersionTimeStamp = 0;

  showBuildTime = environment.showBuildTime;
  isExternal = false;
  displayNavigation = true; //Can be used for full screen mode in future

  isSidePanelExpanded$: Observable<boolean>;
  showBanner = false;

  constructor(
    protected cdr: ChangeDetectorRef,
    private router: Router,
    private oidcSecurityService: OidcSecurityService,
    private store: Store<{}>,
    private sidePanelService: SidePanelService,
    private snackbarService: SnackbarService,
    private appVersionService: AppVersionService,
    private deviceService: DeviceDetectorService,
    private screenWiperService: ScreenWiperService
  ) {
    super(cdr);
  }

  ngOnInit() {
    this.showBanner = this.deviceService.browser === 'Safari';

    this.snackbarService.watchForSidePanel(this.sidePanelService).pipe(untilDestroyed(this)).subscribe();

    this.isSidePanelExpanded$ = this.sidePanelService.isSidePanelExpanded$;

    this.appVersionService.version$
      .pipe(
        untilDestroyed(this),
        distinctUntilChanged(),
        filter(appVersion => appVersion.version_timestamp > 0),
        first(),
        tap(appVersion => {
          this.currentVersionTimeStamp = appVersion.version_timestamp;
          this.currentVersion = appVersion.version_number;
        })
      )
      .subscribe();

    this.isLoading$ = this.store.select(selectLoadEnumerationsLoading);
    this.dashboardViewType$ = this.store.select(selectDashboardViewType);
  }

  toggleSidePanel() {
    this.sidePanelService.toggleSidePanel();
  }

  mainPageActions(action: MainPageActions) {
    switch (action) {
      case MainPageActions.ACCOUNT:
        {
          // todo - redirect to account settings
        }
        break;
      case MainPageActions.PASSWORD:
        {
          // todo - redirect to password settings
        }
        break;
      case MainPageActions.NOTIFICATIONS:
        {
          // todo - redirect to notifications settings
        }
        break;
      case MainPageActions.LOGOUT:
        {
          this.oidcSecurityService.logoff();
          this.isAuthenticated = false;
        }
        break;
      case MainPageActions.LOGIN:
        {
          this.router
            .navigate([AppRoutes.LOGIN], {
              queryParams: {
                returnUrl: window.location.href,
              },
            })
            .then();
        }
        break;
      case MainPageActions.HOME_PAGE:
        {
          this.router.navigate([AppRoutes.HOME]).then();
        }
        break;
    }
  }
}
